import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "./context/ThemeContext";
import FlinchLanding from "./components/FlinchLanding";
import ShiftPage from "./components/ShiftPage";
import WhyUsPage from "./components/WhyUsPage";
import InsightsPage from "./components/InsightsPage";
import ArticleDetailPage from "./components/ArticleDetailPage";
import AdminDashboard from "./components/AdminDashboard";
import FranchiseChatbotPage from "./components/FranchiseChatbotPage";
import ScrollToTop from "./components/ScrollToTop";

// Force load custom fonts
const loadCustomFonts = async () => {
  try {
    // Load Ropan font for various weights
    await Promise.all([
      document.fonts.load('400 1em Ropan'),
      document.fonts.load('700 1em Ropan'),
      document.fonts.load('400 1em Monda'),
      document.fonts.load('700 1em Monda'),
    ]);
    console.log('Custom fonts loaded successfully');
  } catch (error) {
    console.log('Font loading error:', error);
  }
};

function App() {
  // Load fonts on app mount
  useEffect(() => {
    loadCustomFonts();
  }, []);

  return (
    <HelmetProvider>
      <ThemeProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<FlinchLanding />} />
              <Route path="/shift" element={<ShiftPage />} />
              <Route path="/why-us" element={<WhyUsPage />} />
              <Route path="/insights" element={<InsightsPage />} />
              <Route path="/insights/:id" element={<ArticleDetailPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/franchise-chatbot" element={<FranchiseChatbotPage />} />
            </Routes>
          </BrowserRouter>
        </div>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
